import { createSelector } from 'reselect';
import OperationalAnalysisColumns from '../../containers/OperationalAnalysisColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.OPERATIONAL_ANALYSIS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.OPERATIONAL_ANALYSIS.isLoading;

export const getData =
  ReportDefinitions.OPERATIONAL_ANALYSIS.getDataFunction();

export const getColumns =
  createSelector(getData, OperationalAnalysisColumns);
